/* eslint-disable jsx-a11y/anchor-has-content */
import Link from "next/link";

const CustomLink = ({ href, reloadOnClick = false, ...rest }) => {
  const isInternalLink = href && href.startsWith("/");
  const isAnchorLink = href && href.startsWith("#");
  const reloadPage = href && href.startsWith("reload");

  const handleClick = (e) => {
    if (reloadOnClick && typeof window !== "undefined") {
      e.preventDefault();

      if (window.location.pathname === href) {
        window.location.reload();
      } else {
        window.location.href = href;
      }
    }
  };

  if (isInternalLink) {

    if (reloadOnClick) {
      return (
        <a href={href} onClick={handleClick} {...rest} />
      );
    }

    return (
      <Link href={href}>
        <a href={href} {...rest} />
      </Link>
      // <a href={href} {...rest} />
    );
  }

  if (isAnchorLink) {
    return <a href={href} {...rest} />;
  }

  if (reloadPage) {
    return (
      <a
        target="_self"
        rel="noopener noreferrer"
        href={window.location.pathname}
        {...rest}
      />
    );
  }

  return <a target="_blank" rel="noopener noreferrer" href={href} {...rest} />;
};

export default CustomLink;
